import { filter, take } from 'rxjs/operators';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSealPictureControlModel, AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  AllocationViewPerformSealPictureControlAction,
  AllocationViewPerformSealPictureControlActionPrepare,
  AllocationViewPerformSealPictureControlActionSetInitialState,
} from './allocation-view-perform-seal-picture-control-action.actions';
import { AllocationViewPerformSealPictureControlActionState } from './allocation-view-perform-seal-picture-control-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewPerformSealPictureControlActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewPerformSealPictureControlActionState.getLoaded);
  preparedDetails$: Observable<AllocationViewSealPictureControlModel> = this.store.select(
    AllocationViewPerformSealPictureControlActionState.getPreparedDetails,
  );

  constructor(
    private allocationViewActionsFacade: AllocationViewActionsFacade,
    private translateService: TranslateService,
    private store: Store,
  ) {}

  loadAll(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewPerformSealPictureControlActionPrepare(identifier, this.translateService.currentLang),
        );
      });
  }

  performSealPictureControl(pictureControl: AllocationViewSealPictureControlModel): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ type: _type }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewPerformSealPictureControlAction(pictureControl));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewPerformSealPictureControlActionSetInitialState());
  }
}
